import "./tarjetaServicio.css";
import { useNavigate } from "react-router-dom";

const TarjetaServicio = (props) => {
  const navigate = useNavigate();

  return (
    <article className='tarjetas' id={`tarjeta-${props.id}`}>
      <img src={props.img} alt={props.alt} />
      <div className="jbInfoTarjeta">
        <h3>{props.nombre}</h3>
        <p className="descripcion">{props.descripcion}</p>
        <button onClick={() =>
          navigate(`${props.link}`)}
        >Más info</button>
      </div>
    </article>
  )
}

export default TarjetaServicio;